import { render } from "./StatsList.vue?vue&type=template&id=37409934&scoped=true"
import script from "./StatsList.vue?vue&type=script&lang=ts"
export * from "./StatsList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-37409934"

export default script